<template>
    <div class="admin-content">
        <LoadingPlaceholder v-if="loading" />
        <div class="row" v-if="!loading">
            <div class="col-sm-12">
                <div class="float-right">
                    <a @click.prevent="changePage({ page: 'AdminTenantManagementNew' })" :href="newTenantUrl" class="btn btn-primary btn-sm">New</a>
                </div>
                <h1 class="admin-content-heading">Tenants</h1>
                <ul id="formEditTable" class="tree-layout" role="main" aria-label="Tenant Listing">
                    <IndexTenant :tenant="tenant" :key="tenant.code" v-for="tenant in rootTenants" v-on:change-page="changePage($event as ChangePageEvent)" />
                </ul>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent, ref, computed, inject } from "vue";
import LoadingPlaceholder from "@/lib/LoadingPlaceholder.3.vue";
import IndexTenant from "./IndexTenant.3.vue";
import getData from "../../lib/getData";
import { useMainStore } from "@/mainStore";
import { asyncComputed } from "@vueuse/core";
import { TenantViewModel as TenantViewModelTs } from "@cs-ts/tenant-view-model_1";
import { TenantViewModel as TenantViewModelCs } from "@cs/TenantViewModel_1";
import { TenantManagementViewModel } from "@cs/TenantManagementViewModel";
//eslint-disable-next-line @typescript-eslint/no-unused-vars
import { changePageInjectKey, ChangePageEvent } from "@/AppShell.3.vue.InjectKeys";
type TenantViewModelExtended = Omit<TenantViewModelTs, "subtenants"> & { subtenants: TenantViewModelExtended[] };

export default defineComponent({
    components: {
        LoadingPlaceholder,
        IndexTenant,
    },
    setup() {
        const mainStore = useMainStore();

        const loading = ref(true);
        const tenants = ref<TenantViewModelExtended[]>([]);

        const rootTenants = computed(() => {
            return tenants.value
                .filter(i => i.parentCode == null)
                .slice()
                .sort((a, b) => (a.displayLabel || "").localeCompare(b.displayLabel!));
        });

        // const adminUrl = computed(() => {
        //     return mainStore.getUrl("admin");
        // });
        const newTenantUrl = asyncComputed(() => {
            return mainStore.getUrl("adminTenantManagementNew");
        });

        (async () => {
            loading.value = true;
            const tenantListingData: TenantManagementViewModel = await getData(mainStore, "AdminTenantManagementIndex", () => mainStore.getUrl("adminTenantManagementIndexData"));
            tenants.value = tenantListingData.Tenants!.map(
                (i: TenantViewModelCs) =>
                    <TenantViewModelExtended>{
                        code: i.Code,
                        urlSlug: i.UrlSlug,
                        type: i.Type,
                        tier: i.Tier,
                        displayLabel: i.DisplayLabel,
                        description: i.Description,
                        parentCode: i.ParentCode,
                        adminAreaEnabled: i.AdminAreaEnabled,
                        publicAreaEnabled: i.PublicAreaEnabled,
                        subtenants: [],
                    },
            );
            const tenantDict: Record<string, TenantViewModelExtended> = {};
            tenants.value.forEach(i => {
                tenantDict[i.code!] = i;
            });
            tenants.value
                .filter(i => i.parentCode != null)
                .forEach(i => {
                    if (tenantDict[i.parentCode!] != null) {
                        tenantDict[i.parentCode!].subtenants!.push(i);
                    }
                });
            loading.value = false;
        })();

        return {
            loading,
            rootTenants,
            newTenantUrl,

            changePage: inject(changePageInjectKey)!,
        };
    },
});
</script>
